import { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BoxFull, Button, TransactionalSubheader } from "iuvity-ui-components";
import { Header } from "../../components";
import { Badge } from "iuvity-ui-components/dist/badge";
import {
  CustomDialog,
  DialogProps,
} from "../../components/dialog/CustomDialog";
import { useConfigurations } from "../../hooks/useConfigurations";
import {
  getContextFromKey,
  getGlobalConfigurationPageLabel,
} from "../../utils";
import { AppContext } from "../../context/index";
import { PrivilegeValidatorComponent } from "../../components/shared/PrivilegeValidatorComponent";

export const DetailConfigurationPage = () => {
  const pathNotShowFieldFuntionality = ['fieldValidations', 'serverEndpoint', 'security'];
  const location = useLocation();
  const navigate = useNavigate();
  const {
    t,
    appState: { user, selectedConfig, permissiondInfoByRole },
    setAppState,
  } = useContext(AppContext);

  const { configurationAction } = useConfigurations("ACTIONS");
  const [modalProps, setModalProps] = useState<DialogProps>({
    visible: false,
  } as DialogProps);

  const customPageLabel = getGlobalConfigurationPageLabel(
    t,
    location.pathname.substring(0, location.pathname.lastIndexOf("/"))
  );
  const pathContext = getContextFromKey(selectedConfig?.key || "");

  const onReturn = () => {
    setAppState((prev) => ({
      ...prev,
      selectedConfig: null,
    }));
    navigate(-1);
    window.scrollTo(0, 0);
  };

  const onEdit = () => {
    const pathContext = getContextFromKey(selectedConfig?.key || "");
    navigate(`/configurations/${pathContext}/edit`);
  };

  const onDelete = async () => {
    const actionStatus = await configurationAction(
      "DELETE",
      selectedConfig?.id
    );
    if (actionStatus === "SUCCESS") navigate(-1);
  };

  const handleModalProps = () => {
    setModalProps((prev) => ({
      ...prev,
      visible: true,
      title: t("GlobalConfigurations.deleteModalTitle"),
      content: `${t("GlobalConfigurations.deleteModalContent1")} "${
        selectedConfig?.key
      }" ${t("GlobalConfigurations.deleteModalContent2")}`,
      onConfirm: () => onDelete(),
    }));
  };

  return (
    <>
      {/* <Header
        welcomeMessage={t("Dashboard.welcomeTitle")}
        userName={user?.name}
      /> */}

      <TransactionalSubheader
        subheaderTitle={
          <div style={{ position: "relative", left: "-40px" }}>
            <i
              className="iu iu-icon-left pr-3"
              onClick={onReturn}
              aria-hidden="true"
              style={{
                fontSize: "var(--font-size-tablet-title)",
                cursor: "pointer",
              }}
            />
            {t("GlobalConfigurations.detailTitle")}
          </div>
        }
      >
        <TransactionalSubheader.BreadCrumb
          id={t("GlobalConfigurations.breadcrumbParentLabel")}
          disabledDefaultHome={true}
          breadcrumbsHomeItem={{
            icon: "iu iu-icon-home",
            command: () => navigate("/"),
          }}
          breadcrumbsItems={[
            {
              label: customPageLabel,
              command: () => onReturn(),
              style: { fontFamily: "var(--fontBarlowSemiBold)" },
            },
            {
              label: t("GlobalConfigurations.detailTitle"),
              disabled: true
            },
          ]}
        />
        <TransactionalSubheader.Title />
      </TransactionalSubheader>

      <BoxFull
        className="mt-5 mb-3 p-0"
        style={{ backgroundColor: "transparent" }}
      >
        <BoxFull variant="secondary">
          <BoxFull className="my-5 py-2">
            <div className="flex-column align-items-center justify-content-center">
              <div className="flex align-items-center justify-content-center mt-4">
                <div className="inputlabel subtitle p-1">
                  {t("GlobalConfigurations.statusLabel")}
                </div>
              </div>
              <div className="flex align-items-center justify-content-center mb-3">
                <Badge
                  className={`flow-badge mt-2 ${selectedConfig?.status}`}
                  value={t(
                    `GlobalConfigurations.${selectedConfig?.status.toLowerCase()}StatusLabel`
                  )}
                />
              </div>

              <div className="dt-appr-c">
                <div className="dt-ap-col">
                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("GlobalConfigurations.keyLabel")}
                    </div>
                    <div className="item-value">{selectedConfig?.key?.split(".").pop()}</div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("GlobalConfigurations.descriptionLabel")}
                    </div>
                    <div className="item-value">
                      {selectedConfig?.description}
                    </div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("GlobalConfigurations.versionColumnTitle")}
                    </div>
                    <div className="item-value">
                      {selectedConfig?.releaseversion}
                    </div>
                  </div>
                </div>

                <div className="dt-ap-col">
                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("GlobalConfigurations.valueLabel")}
                    </div>
                    <div className="item-value">{selectedConfig?.value}</div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("GlobalConfigurations.typeLabel")}
                    </div>
                    <div className="item-value">
                      {t(
                        `GlobalConfigurations.${
                          selectedConfig?.type === "number"
                            ? "numeric"
                            : selectedConfig?.type
                        }OptionLabel`
                      )}
                    </div>
                  </div>

                  {!pathNotShowFieldFuntionality.includes(pathContext) && (
                    <div className="dt-ap-item">
                      <div className="item-title">{t('GlobalConfigurations.widgetsLabel')}</div>
                      <div className="item-value">{selectedConfig?.widgets?.map((widget) => (
                        <div>{widget}</div>))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </BoxFull>
        </BoxFull>
      </BoxFull>

      <BoxFull className="my-5">
        <div className="flex align-items-start justify-content-center">
          <div className="inputlabel subtitle p-1">{`${t(
            "GlobalConfigurations.creationDateLabel"
          )}:`}</div>
          <div className="inputlabel label px-1">{`${selectedConfig?.createdat}`}</div>
        </div>
        <div className="flex align-items-start justify-content-center">
          <div className="inputlabel subtitle p-1">{`${t(
            "GlobalConfigurations.creatorLabel"
          )}:`}</div>
          <div className="inputlabel label px-1">
            {selectedConfig?.createdby || "System"}
          </div>
        </div>
      </BoxFull>

      <BoxFull className="my-5 p-0" style={{ backgroundColor: "transparent" }}>
        <div className="flex align-items-center justify-content-end gap-5">
          <Button
            variant="p-button-link"
            label={t("GlobalConfigurations.returnBtnLabel")}
            onClick={onReturn}
          />
          {selectedConfig?.iscustomconfiguration && (
            <PrivilegeValidatorComponent showButton={permissiondInfoByRole.REMOVE} >
              <Button
                variant="p-button-link"
                label={t("TableActions.deleteLabel")}
                onClick={handleModalProps}
              />
            </PrivilegeValidatorComponent>
          )}
         <PrivilegeValidatorComponent showButton={permissiondInfoByRole.UPDATE} >
          <Button
            variant="p-button"
            label={t("TableActions.editLabel")}
             onClick={onEdit}
          />
         </PrivilegeValidatorComponent>
        </div>
      </BoxFull>

      <CustomDialog
        title={modalProps.title}
        content={modalProps.content}
        visible={modalProps.visible}
        handleModalState={setModalProps}
        onConfirm={modalProps.onConfirm}
      />
    </>
  );
};
